export default __webpack_public_path__ + "static/media/sd-check.06c5ca64.svg";